import Box from '@totallymoney/ui/components/Box'
import Text from '@totallymoney/ui/components/Text'

import { StyledCell } from '../RatesAndFees.styled'

const Cell = ({
    label,
    value,
    icon,
}: {
    icon?: React.ReactNode
    label?: string
    value?: string
}) => {
    return (
        <StyledCell
            display={[label == null ? 'none' : 'flex', 'flex']}
            alignItems="center"
        >
            <Box display="flex">
                <Text>{label ?? ''}</Text>
                {icon ? (
                    <Box ml="space10" display="flex" justifyItems="center">
                        {icon}
                    </Box>
                ) : null}
            </Box>
            <Box pl="space20">
                <Text weight="bold">{value ?? ''}</Text>
            </Box>
        </StyledCell>
    )
}

export default Cell
